export default __webpack_public_path__ + "static/media/vision_icon.66b90561.svg";